interface FooterSection {
  title: string;
  items: {
    title: string;
    link: string;
    dataLink?: string;
  }[];
}

interface FooterConfig {
  sections: FooterSection[];
}

export const footerConfigs: Record<string, FooterConfig> = {
  okie: {
    sections: [
      {
        title: 'customerCare',
        items: [
          {
            title: 'contactUs',
            link: '/customer-care',
            dataLink: 'footer-contact',
          },
          {
            title: 'payment',
            link: '/payment',
            dataLink: 'footer-payment',
          },
          {
            title: 'faq',
            link: '/faq',
            dataLink: 'footer-faq',
          },
        ],
      },
      {
        title: 'about',
        items: [
          {
            title: 'aboutUs',
            link: '/about',
            dataLink: 'footer-about',
          },
        ],
      },
      {
        title: 'legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals#terms-and-conditions',
            dataLink: 'footer-terms',
          },
          {
            title: 'legals:privacyPolicy',
            link: '/legals#privacy-policy-main',
            dataLink: 'footer-privacy',
          },
        ],
      },
    ],
  },
  heimkaup: {
    sections: [
      {
        title: 'Legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals#terms-and-conditions',
            dataLink: 'footer-terms',
          },
          {
            title: 'privacyNotice',
            link: '/legals#privacy-policy-main',
            dataLink: 'footer-privacy',
          },
        ],
      },
    ],
  },
  default: {
    sections: [
      {
        title: 'legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals',
            dataLink: 'footer-terms',
          },
        ],
      },
    ],
  },
};
